(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-free-shipping-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    const THRESHOLD = 4990;

    function formatMoney(cents) {
      return new Intl.NumberFormat('en-IE', {
        style: 'currency',
        currency: 'EUR'
      }).format(cents / 100);
    }

    function updateBar(total) {
      const wrapper = document.getElementById('fsb-wrapper');
      if (!wrapper) return;

      const fill = document.getElementById('fsb-fill');
      const msg  = document.getElementById('fsb-message');
      const pct  = Math.min((total / THRESHOLD) * 100, 100);

      fill.style.width = pct + '%';

      if (total >= THRESHOLD) {
        fill.classList.add('fsb-fill--done');
        msg.innerHTML = '🎉 You\'ve unlocked free shipping!';
      } else {
        fill.classList.remove('fsb-fill--done');
        const remaining = formatMoney(THRESHOLD - total);
        msg.innerHTML = 'Add <strong>' + remaining + '</strong> more for free shipping';
      }
    }

    document.addEventListener('cart:updated', function (e) {
      if (e.detail?.cart?.total_price !== undefined) {
        updateBar(e.detail.cart.total_price);
      }
    });

    fetch('/cart.js')
      .then(r => r.json())
      .then(c => updateBar(c.total_price));
  })();
  } catch(e) { console.error(e); }
})();

})();
